/**
 * Types and structures for managing user authentication.
 */
export const CSRF_TOKEN_HEADER = 'X-XSRF-Token';
export var Permission;
(function (Permission) {
    // values are bit flags and therefore powers of 2
    Permission[Permission["None"] = 0] = "None";
    Permission[Permission["Admin"] = 1] = "Admin";
    Permission[Permission["Edit"] = 2] = "Edit";
    Permission[Permission["Coords"] = 4] = "Coords"; // placeholder permission, needed for testing functioning of permission
})(Permission || (Permission = {}));
export function toResetQueryStr(email, resetCode) {
    return `?action=reset&email=${encodeURI(email)}&code=${resetCode}`;
}
